import apiService from '@/services/apiService';

const actions = {
  getFootnote({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('footnote/find-one')
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postFootnote({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('footnote/insert-or-update', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
